import { render, staticRenderFns } from "./ProductDesignFormThreadEdit.vue?vue&type=template&id=4295a362&"
import script from "./ProductDesignFormThreadEdit.vue?vue&type=script&lang=js&"
export * from "./ProductDesignFormThreadEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports